(ns practitest.frontend.components2.dashboard.charts.marks
  (:require [practitest.frontend.components2.dashboard.charts.marks-gen :as gen]))

(defmulti render!
  (fn [_svg-g mark _spec] (:type mark)))

(defn- grouping-field [encode]
  (or (get-in encode [:color :field])
      (get-in encode [:detail :field])))

(defn- sorting-field [encode]
  (or (get-in encode [:order :field])
      (get-in encode [:x :field])))

(defn- prepare-data [encode data]
  (let [grp-field (grouping-field encode)
        srt-field (sorting-field encode)]
    (-> data
        (cond->>
            (vector? data) (group-by grp-field))
        (update-vals #(vec (sort-by srt-field %))))))

(defmethod render! :line
  [svg _mark {:keys [data encode] :as ctx}]
  (let [svg-g       (.select svg "g.chart g.marks")
        color-scale (get-in encode [:color :d3-scale])
        line-gen    (gen/line ctx)
        series   (->> data
                      (prepare-data encode)
                      (mapv (fn [[k line-data]]
                              {:key    (some-> k name)
                               :color  (when color-scale (color-scale k))
                               :points line-data})))
        paths    (-> svg-g
                     (.selectAll "path.mark-line")
                     (.data (clj->js series) (fn [d] (aget d "key"))))]
    (-> (.enter paths)
        (.append "path")
        (.attr "class" (fn [d] (str "mark-line " (aget d "key"))))
        (.attr "fill" "none")
        (.attr "stroke-width" 2)
        (.merge paths)
        (.attr "stroke" (fn [d] (or (aget d "color") "#888")))
        (.attr "d" (fn [d] (line-gen (aget d "points")))))
    (-> (.exit paths)
        (.remove))))

